// Disabled links
$(document).on("click", "a[disabled]", function(e) {
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});

var beforeNavScroll = null;

$("#nav-trigger").on( "click" , function(e) {
	e.preventDefault();

	var $body = $(document.body);

	if ($body.hasClass("nav-visible")) {
		$body.removeClass("nav-visible");
		$(window).scrollTop(beforeNavScroll);
	}
	else {
		beforeNavScroll = $(window).scrollTop();
		$body.addClass("nav-visible");
	}

});

// mobile toggle 
$(".main-nav__child-toggler").on( "click" , function(e) {
	e.preventDefault();

	var parent = $(this).closest(".main-nav__item--has-childrens");

	parent.toggleClass('main-nav__item--show-childrens');

});

$(".js-footer-menu-toggler").on( "click" , function(e) {
	e.preventDefault();

	var parent = $(this).closest(".footer__nav");

	parent.toggleClass('footer__nav-toggle');

});

// Android check
var ua = navigator.userAgent.toLowerCase();
var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");

if (isAndroid) {
	$("html").addClass("android");
}

// iOS Check
if (/ip(hone|od)|ipad/i.test(navigator.userAgent)) {
	$("html").addClass("is-ios");
	// $(document.body).css("cursor", "pointer");
}


// Attach dynamic click listeners
$(document).on("click", "[data-trigger=click]", function(e) {
	if ($(this).data()["preventDefault"]) {
		e.preventDefault();
	}

	var params = [];

	if ($(this).attr("data-params")) {
		params = eval("[" + $(this).attr("data-params") + "]");
	}

	params.push(e);

	var controller = eval($(this).attr("data-controller"));
	controller.apply(this, params);
});


var priceSlider = $("#price-slider");

if (priceSlider.length) {

	var sliderOptions = {
		start: [ 
			parseFloat(priceSlider.attr("data-min-value"), 10), 
			parseFloat(priceSlider.attr("data-max-value"), 10)
		],
		margin: 1,
		connect: true,
		behaviour: "snap",
		range: {
			min: parseFloat(priceSlider.attr("data-min"), 10),
			max: parseFloat(priceSlider.attr("data-max"), 10)
		}
	};


	if (sliderOptions.range.min == sliderOptions.range.max) 
	{
		if (sliderOptions.range.min > 1) {
			sliderOptions.range.min--;
			sliderOptions.start[0] = sliderOptions.range.min;
		}
		else {
			sliderOptions.range.max++;
			sliderOptions.start[1] = sliderOptions.range.max;
		}
	}

	noUiSlider.create(priceSlider[0], sliderOptions);

	var minPriceInput = priceSlider.siblings(".min-price-input");
	var maxPriceInput = priceSlider.siblings(".max-price-input");
	var minPriceText = priceSlider.siblings(".filter__values").find(".price-slider-min span");
	var maxPriceText = priceSlider.siblings(".filter__values").find(".price-slider-max span");

	priceSlider[0].noUiSlider.on("update", function (values, handle) {

		var value = values[handle];

		value = parseInt(value, 10);

		if (handle) {
			maxPriceText.text(value);
		} else {
			minPriceText.text(value);
		}
	});

	priceSlider[0].noUiSlider.on("set", function (values, handle) {

		var value = values[handle];

		value = parseInt(value, 10);

		if (handle) {
			maxPriceInput.val(value).change();
			maxPriceText.text(value);
		} else {
			minPriceInput.val(value).change();
			minPriceText.text(value);
		}
	});
}

if ($(".gallery--picture").length) {
	// Photoswipe init        
	$(".gallery--picture").photoSwipe(
		".gallery__item-container",
		{
			bgOpacity: 0.8,
			shareEl: false,
			captionEl: false,
			tapToClose: true
		}
	);
}

$(".accordeon__title").on("click", function() {

	var accordeon = $(this).closest(".accordeon");
	accordeon.toggleClass("accordeon--expanded");

});

//mobile profile
var $profileBtn = $(".js-floating-btn");
var $profileMenu = $(".js-floating-profile");


$profileBtn.on("click", function(e) {

	if (e) {
			e.preventDefault();
			e.stopPropagation();
	}

	if ($profileMenu.is(":hidden")) {

		$profileMenu.addClass("floating__profile--visible");
		$profileBtn.addClass("floating-btn--active");

	} else {

		$profileMenu.removeClass("floating__profile--visible");
		$profileBtn.removeClass("floating-btn--active");

	}

	$(document).click(function() {

		//Hide the menus if visible
		if ($profileMenu.is(":visible")) {

			$profileMenu.removeClass("floating__profile--visible");
			$profileBtn.removeClass("floating-btn--active");

		}
	});
});

$(".js-capacity-select").on("change", function() {

	var selected = $(this).find("option:selected");

	if (selected.attr("data-href")) {
			window.location = selected.attr("data-href");
	}

});

$(".js-toggle-filter").on("click", function(e) {
	e.preventDefault();

	var scrollTop = $(window).scrollTop();
	var bodyTop = -1 * parseFloat($(document.body).css("top"), 10);

	$(document.body).toggleClass("filter-mobile--show");

	if ($(document.body).hasClass("filter-mobile--show")) {
		$(document.body).css("top", -scrollTop + "px")
	}
	else {
		$(window).scrollTop(bodyTop);
	}
});


// Overlay close
$(".page-overlay").on("click", function() {

	var bodyTop = -1 * parseFloat($(document.body).css("top"), 10);

	$(document.body).removeClass("filter-mobile--show");
	
	$(window).scrollTop(bodyTop);

});


//toggle invoince
$('.js-toggle-invoice').change(function() {

	if ($(this).is(":checked")) {
			$( ".invoice" ).addClass('invoice--show');
	}
	else {
		$( ".invoice" ).removeClass('invoice--show');
	}

	$(window).resize();
	$(window).scroll();
 
});

$(".form__picker-overlay").each(function(ind, val) {

	var today = new Date();
	today.setHours(0);
	today.setMinutes(0);
	today.setSeconds(0);
	today.setMilliseconds(0);

	$(val).datepicker({
		minDate: today,
		title: "Изберете дата",
		target: $(val).prev("input")
	});
	
});

$(document).on("change", ".js-radio-toggler input[type=radio]", function() {

	if (!$(this).is(":checked")) {
		return;
	}

	var togglerGroup = $(this).closest(".js-radio-toggler");
	var radios = togglerGroup.find("input[type=radio]");
	var toggleSelector = $(this).attr("data-toggle");
	var selector = [];

	$.each(radios, function(ind, val) {
		selector.push($(val).attr("data-toggle"));
	});

	selector = selector.join(", ");

	$(selector).hide();

	if ($(this).is(":checked")) {
		$(toggleSelector).show();
	}

});

if (typeof IntersectionObserver !== "undefined") {
	var $documentBody = $(document.body);

	var cartObserver = new IntersectionObserver(function(entries, observer) {

		for (entry in entries) {

			if (!entries[entry].isIntersecting) {
				$documentBody.addClass("desktop-floating-visible");
			}
			else {
				$documentBody.removeClass("desktop-floating-visible");
			}

		} 

	},{});

	cartObserver.observe($(".header .btn-cart")[0]);
}

$(".gdpr-agree-checkbox").on("change", function() {
	var submitButton = $(this).closest("form").find("button");

	if ($(this).is(":checked")) {
		submitButton.attr("disabled", false);
	} else {
		submitButton.attr("disabled", true);
	}

}).trigger("change");


const filterIcon = document.querySelector('.btn--filter');

if(filterIcon) {
	
  $(window).scroll(function() {
    if($(this).scrollTop() >= 200){
        $('.btn--filter').addClass('show-filter');
    } else {
		$('.btn--filter').removeClass('show-filter');
	}
  });

}

// Read more button/hide-show text
(function() {
	var texts = $('.read-more-text');

	texts.each(function() {
		var text = $(this),
			parent = text.parent('div'),
			btn    = parent.find('.morelink'),
			wait   = text.data('wait'),
			height = text.data('height');
			
		if(text.length) {
		
			setTimeout(function() { 
				text.css('overflow', 'hidden');
				text.addClass('visible');
				text.animate({'height': height}); 
			}, wait);
			var h = text[0].scrollHeight;
			if(h > height) {
				btn.addClass('less');
				btn.css('display', 'inline-block');
			}
		
			btn.click(function(e) {
				e.stopPropagation();
		
				if(btn.hasClass('less')) {
					btn.removeClass('less');
					btn.addClass('more');
					btn.text('Скрий');
					text.css('overflow', 'visible');
					text.removeClass('visible');
					text.animate({'height': h});
				} else {
					btn.addClass('less');
					btn.removeClass('more');
					btn.text('Прочети още');
					text.css('overflow', 'hidden');
					text.addClass('visible');
					text.animate({'height': height});
				}
			});
		}
	});

		
	
	
	$(document).on('click', '.clever-link', function(e){
		if($(this).data('prevent')) {
			return false;
		} else {
			window.open($(this).data('link'), "_self");
		}
		
	});
})();
